import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { func, bool, string } from 'prop-types'
// import { saveKeenEvent } from '../utils/KeenTracking'
import FormInput from './FormInput'

// const required = (value) => {
//   if (value) {
//     return undefined
//   } else {
//     saveKeenEvent('tried-to-signup', { error: 'required' })
//     return 'Campo obrigatório'
//   }
// }
// const passwordSize = (value) => {
//   if (value.length <= 8) {
//     saveKeenEvent('tried-to-signup', { error: 'length_less_than_8' })
//     return 'Sua senha deve ter 8 ou mais caracteres'
//   } else {
//     return undefined
//   }
// }

const ModalPasswordForm = ({
  error,
  handleSubmit,
  pristine,
  submitting
}) => {
  let buttonLabel = 'Salvar'
  if (submitting) {
    buttonLabel = 'salvando...'
  }
  return (
    <form onSubmit={handleSubmit}>
      <div className='form-group'>
        <Field
          type='password'
          name='password'
          component={FormInput}
          label='Digite sua senha:'
          placeholder='Senha'
          direction='vertical'
        />
      </div>

      <div className='form-group'>
        <Field
          type='password'
          name='password_confirmation'
          component={FormInput}
          label='Confirme a senha:'
          placeholder='Confirmação de senha'
          direction='vertical'
        />
      </div>
      {error &&
        <div className='panel panel-danger'>
          <div className='panel-heading'></div>
          <div className='panel-body'>
            <strong className='text-danger'>{error}</strong>
          </div>
        </div>
      }
      <div className='form-group'>
        <div className='pull-right'>
          <button type='submit' className='btn btn-primary ml10' disabled={submitting}>{buttonLabel}</button>
        </div>
      </div>
    </form>
  )
}

ModalPasswordForm.propTypes = {
  handleSubmit: func,
  pristine: bool,
  submitting: bool,
  error: string
}

export default reduxForm({ form: 'modalSetPassword' })(ModalPasswordForm)



// WEBPACK FOOTER //
// ./src/components/ModalPasswordForm.js